import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/logo.png";
import bgVideo from "../../assets/finance-bg.mp4";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../../components/Footer/Footer";

// React Icons imports
import { FaBaby, FaSeedling, FaBookOpen, FaHandHoldingHeart, FaTractor, FaCarrot, FaChalkboardTeacher, FaUtensils, FaVial, FaFish, FaUserMd, FaSchool, FaUsers } from "react-icons/fa";
import { MdOutlineEmojiFoodBeverage, MdSoupKitchen, MdOutlineWaterDrop, MdOutlineLocalHospital, MdOutlineFastfood } from "react-icons/md";
import { GiFarmTractor, GiWheat, GiWateringCan, GiMeat, GiCookingPot, GiPlantSeed, GiChicken, GiFruitBowl, GiWell } from "react-icons/gi";
import { IoNutrition, IoLeafOutline } from "react-icons/io5";
import { BsDropletFill, BsExclamationTriangleFill, BsGraphDownArrow, BsLightbulb } from "react-icons/bs";
import { RiPlantLine, RiGovernmentLine, RiEmotionSadLine, RiAlarmWarningLine } from "react-icons/ri";
import { HiOutlineAcademicCap, HiOutlineUsers } from "react-icons/hi";
import { TbToiletPaper, TbHandSanitizer } from "react-icons/tb";
import { LuSprout, LuMilk, LuHeart } from "react-icons/lu";
import { PiBabyBold, PiPlantBold, PiCookingPotBold } from "react-icons/pi";

/* ============================================================
   GLOBAL STYLES
   ============================================================ */
const GlobalStyles = () => (
  <style>{`
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; background: #fdf8f0; color: #1a1000; overflow-x: hidden; }
    .syne { font-family: 'Syne', sans-serif; }
    .playfair { font-family: 'Playfair Display', serif; }

    .ripple-span {
      position: absolute; border-radius: 50%; transform: scale(0);
      animation: rippleAnim 650ms linear; background: rgba(255,255,255,0.35);
      pointer-events: none;
    }
    @keyframes rippleAnim { to { transform: scale(4); opacity: 0; } }
    @keyframes loaderSpin { to { transform: rotate(360deg); } }
    .loader-ring {
      width: 52px; height: 52px; border-radius: 50%;
      border: 3px solid rgba(234,179,8,0.2);
      border-top-color: #eab308;
      animation: loaderSpin 0.8s linear infinite;
    }
    @keyframes heroFadeUp   { from { opacity:0; transform:translateY(40px); } to { opacity:1; transform:translateY(0); } }
    @keyframes heroScale    { from { opacity:0; transform:scale(0.85); } to { opacity:1; transform:scale(1); } }
    @keyframes floatY       { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-14px); } }
    @keyframes orbPulse     { 0%,100% { transform:scale(1) translate(0,0); } 33% { transform:scale(1.08) translate(6px,-8px); } 66% { transform:scale(0.94) translate(-4px,6px); } }
    @keyframes countUp      { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    @keyframes shine        { 0% { left:-100%; } 100% { left:200%; } }
    @keyframes spin         { to { transform:rotate(360deg); } }
    @keyframes navSlideDown { from { transform:translateY(-100%); opacity:0; } to { transform:translateY(0); opacity:1; } }
    @keyframes pulse        { 0%,100% { opacity:1; } 50% { opacity:0.6; } }
    @keyframes cardIn       { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }

    .hover-lift { transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease; }
    .hover-lift:hover { transform: translateY(-6px); }

    .gradient-text-amber {
      background: linear-gradient(135deg, #eab308 0%, #f59e0b 50%, #fbbf24 100%);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
    }

    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: #fdf8f0; }
    ::-webkit-scrollbar-thumb { background: #eab308; border-radius: 3px; }

    .btn { position:relative; overflow:hidden; cursor:pointer; border:none; font-family:'DM Sans',sans-serif; font-weight:500; transition:all 0.25s ease; }
    .btn:active { transform:scale(0.97); }

    .grid-pattern-amber {
      background-image: linear-gradient(rgba(234,179,8,0.07) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(234,179,8,0.07) 1px, transparent 1px);
      background-size: 48px 48px;
    }

    .dot-pattern-amber {
      background-image: radial-gradient(circle, rgba(234,179,8,0.18) 1px, transparent 1px);
      background-size: 28px 28px;
    }

    .stripe-bg-amber {
      background-image: repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 8px,
        rgba(234,179,8,0.04) 8px,
        rgba(234,179,8,0.04) 16px
      );
    }

    .tab-underline { position: relative; }
    .tab-underline::after {
      content: ''; position: absolute; bottom: -3px; left: 0;
      height: 2px; background: #eab308;
      width: 0; transition: width 0.35s ease;
    }
    .tab-underline.active::after { width: 100%; }

    .domain-card { transition: all 0.35s cubic-bezier(0.34,1.2,0.64,1); cursor: default; }
    .domain-card:hover { transform: translateY(-8px) scale(1.015); }

    .testi-card { transition: all 0.3s ease; }
    .testi-card:hover { transform: translateY(-5px); }

    .faq-item { transition: background 0.25s ease; }
    .faq-item:hover { background: #fffbeb !important; }

    @media (min-width: 768px) { .hamburger { display: none !important; } }
    @media (max-width: 767px) { .desktop-links, .desktop-btns { display: none !important; } }

    @media (max-width: 640px) {
      .mission-grid { grid-template-columns: 1fr !important; }
      .actions-grid { grid-template-columns: 1fr !important; }
    }
  `}</style>
);

/* ============================================================
   PAGE LOADER
   ============================================================ */
const PageLoader = ({ loading }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!loading) {
      const t = setTimeout(() => setVisible(false), 600);
      return () => clearTimeout(t);
    }
  }, [loading]);
  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#1a0e00',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.25rem',
      transition: 'opacity 0.6s ease',
      opacity: loading ? 1 : 0,
    }}>
      <img src={logo} alt="Logo" style={{ width: 48, height: 48, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.1em' }}>
        TUMAINI LETU
      </p>
    </div>
  );
};

/* ============================================================
   RIPPLE BUTTON
   ============================================================ */
const RippleButton = ({ children, style = {}, className = '', onClick }) => {
  const handleClick = (e) => {
    const btn = e.currentTarget;
    const span = document.createElement('span');
    const sz = Math.max(btn.clientWidth, btn.clientHeight);
    const rect = btn.getBoundingClientRect();
    span.className = 'ripple-span';
    Object.assign(span.style, {
      width: sz + 'px', height: sz + 'px',
      left: e.clientX - rect.left - sz / 2 + 'px',
      top: e.clientY - rect.top - sz / 2 + 'px',
    });
    btn.querySelectorAll('.ripple-span').forEach(s => s.remove());
    btn.appendChild(span);
    onClick && onClick(e);
  };
  return (
    <button className={`btn ${className}`} style={style} onClick={handleClick}>
      {children}
    </button>
  );
};

/* ============================================================
   NAVBAR
   ============================================================ */
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const links = ['Accueil', 'Environnement', 'Agriculture','Nutrition'];

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    const fn = () => { if (window.innerWidth >= 768) setMenuOpen(false); };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 100,
      transition: 'all 0.4s ease',
      background: scrolled ? 'rgba(253,248,240,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(234,179,8,0.12)' : '1px solid transparent',
      animation: 'navSlideDown 0.6s ease both',
    }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '0 1.25rem', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={() => window.location.href = '/'} style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', background: 'none', border: 'none', cursor: 'pointer' }}>
          <img src={logo} alt="Logo" style={{ width: 30, height: 30, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
          <span className="syne" style={{ fontWeight: 700, fontSize: 17, color: scrolled ? '#1a1000' : '#fff' }}>
            Tumaini Letu
          </span>
        </button>

        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-links">
          {links.map(l => (
            <button key={l} onClick={() => { if (l === 'Accueil') window.location.href = '/'; if (l === 'Environnement') window.location.href = '/environnement';if (l === 'Agriculture') window.location.href = '/agriculture'; }} style={{
              fontSize: 14, fontWeight: l === 'Nutrition' ? 600 : 400,
              color: l === 'Nutrition' ? '#2563eb' : (scrolled ? '#4a3000' : 'rgba(255,255,255,0.8)'),
              background: 'none', border: 'none', cursor: 'pointer',
              transition: 'color 0.2s', fontFamily: 'DM Sans, sans-serif',
            }}
              onMouseEnter={e => e.target.style.color = '#eab308'}
              onMouseLeave={e => e.target.style.color = l === 'Nutrition' ? '#eab308' : (scrolled ? '#4a3000' : 'rgba(255,255,255,0.8)')}
            >{l}</button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '0.6rem' }} className="desktop-btns">
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: '#eab308', color: '#fff', fontSize: 13, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: 'transparent', color: scrolled ? '#eab308' : '#fff', border: `1.5px solid ${scrolled ? '#eab308' : 'rgba(255,255,255,0.5)'}`, fontSize: 13, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="hamburger" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', display: 'flex', flexDirection: 'column', gap: 5 }}>
            {[0, 1, 2].map(i => (
              <span key={i} style={{
                display: 'block', width: 22, height: 2,
                background: scrolled ? '#1a1000' : '#fff',
                borderRadius: 2, transition: 'all 0.3s ease',
                transform: menuOpen ? (i === 0 ? 'rotate(45deg) translate(5px,5px)' : i === 2 ? 'rotate(-45deg) translate(5px,-5px)' : 'scaleX(0)') : 'none',
                opacity: menuOpen && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        </div>
      </div>

      <div style={{
        overflow: 'hidden', background: 'rgba(253,248,240,0.97)', backdropFilter: 'blur(20px)',
        maxHeight: menuOpen ? 400 : 0, transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)',
        borderTop: menuOpen ? '1px solid rgba(234,179,8,0.1)' : 'none',
      }}>
        <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
          {links.map(l => (
            <a key={l} href="#" onClick={() => setMenuOpen(false)} style={{
              display: 'block', padding: '0.75rem 0',
              borderBottom: '1px solid rgba(234,179,8,0.08)',
              color: l === 'Nutrition' ? '#eab308' : '#4a3000',
              textDecoration: 'none', fontSize: 15,
              fontWeight: l === 'Nutrition' ? 600 : 400,
              fontFamily: 'DM Sans, sans-serif',
            }}>{l}</a>
          ))}
          <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '0.75rem' }}>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: '#eab308', color: '#fff', fontSize: 14, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: 'transparent', color: '#eab308', border: '1.5px solid #eab308', fontSize: 14, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

/* ============================================================
   STAT CARD
   ============================================================ */
const StatCard = ({ label, value, sub, accentColor, icon: IconComponent, delay }) => (
  <div style={{
    position: 'relative', overflow: 'hidden',
    borderRadius: 20,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    backdropFilter: 'blur(20px)',
    padding: '1.4rem 1.5rem',
    cursor: 'default',
    animation: `cardIn 0.7s cubic-bezier(0.34,1.3,0.64,1) ${delay}s both`,
    transition: 'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), border-color 0.3s',
  }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)'; e.currentTarget.style.borderColor = accentColor + '60'; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; }}
  >
    <div style={{ position: 'absolute', top: -32, right: -32, width: 100, height: 100, borderRadius: '50%', background: accentColor, opacity: 0.18, filter: 'blur(28px)', pointerEvents: 'none' }} />
    <div style={{ position: 'absolute', top: 14, right: 16, opacity: 0.15, lineHeight: 1 }}>
      {IconComponent && <IconComponent size={28} color="#fff" />}
    </div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      <p style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: '0.65rem', fontFamily: 'Syne, sans-serif' }}>{label}</p>
      <h2 style={{ fontSize: 26, fontWeight: 700, color: '#fff', fontFamily: 'Syne, sans-serif', marginBottom: '0.5rem', animation: `countUp 0.5s ease ${delay + 0.2}s both` }}>{value}</h2>
      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>{sub}</p>
    </div>
  </div>
);

/* ============================================================
   HERO SECTION
   ============================================================ */
const Hero = ({ video }) => {
  const videoRef = useRef(null);
  useEffect(() => {
    const fn = () => {
      if (videoRef.current) videoRef.current.style.transform = `scale(${1 + window.scrollY / 5000})`;
    };
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // const stats = [
  //   { label: 'Enfants pris en charge', value: '5,200+', sub: 'Malnutrition aiguë', accentColor: '#eab308', icon: PiBabyBold, delay: 0.5 },
  //   { label: 'Familles soutenues', value: '1,800+', sub: 'Vivres distribués', accentColor: '#f97316', icon: GiWheat, delay: 0.65 },
  //   { label: 'Formations réalisées', value: '320+', sub: 'Éducation nutritionnelle', accentColor: '#84cc16', icon: FaBookOpen, delay: 0.8 },
  // ];

  return (
    <header style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', color: '#fff', display: 'flex', flexDirection: 'column' }}>
      <video ref={videoRef} autoPlay loop muted playsInline style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        objectFit: 'cover', transition: 'transform 0.1s linear',
      }}>
        <source src={video} type="video/mp4" />
      </video>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(160deg, rgba(26,14,0,0.93) 0%, rgba(26,14,0,0.78) 50%, rgba(40,20,0,0.75) 100%)' }} />
      {[
        { size: 500, color: '#eab308', top: '-15%', right: '-10%', dur: '12s', opacity: 0.1 },
        { size: 400, color: '#f97316', bottom: '-10%', left: '-8%', dur: '16s', opacity: 0.08 },
        { size: 280, color: '#fbbf24', top: '30%', left: '15%', dur: '9s', opacity: 0.06 },
      ].map((o, i) => (
        <div key={i} style={{
          position: 'absolute', width: o.size, height: o.size, borderRadius: '50%',
          background: o.color, top: o.top, bottom: o.bottom, left: o.left, right: o.right,
          filter: `blur(${o.size / 2.5}px)`, opacity: o.opacity, pointerEvents: 'none',
          animation: `orbPulse ${o.dur} ease-in-out infinite ${i * 2}s`,
        }} />
      ))}
      <div className="grid-pattern-amber" style={{ position: 'absolute', inset: 0, opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{
        position: 'relative', zIndex: 2,
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '7rem 1.5rem 3.5rem',
        textAlign: 'center',
      }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          padding: '0.4rem 1rem', borderRadius: 99,
          background: 'rgba(234,179,8,0.12)', border: '1px solid rgba(234,179,8,0.3)',
          marginBottom: '1.5rem',
          animation: 'heroFadeUp 0.6s ease 0.1s both',
        }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#eab308', display: 'inline-block', animation: 'spin 3s linear infinite' }} />
          <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(234,179,8,0.9)', letterSpacing: '0.1em', fontFamily: 'Syne, sans-serif' }}>
            PROGRAMME NUTRITIONNEL D'URGENCE
          </span>
        </div>
        <div style={{ animation: 'heroFadeUp 0.7s ease 0.2s both', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: 160, height: 140, objectFit: 'contain', animation: 'pulse 1.5s infinite', marginBottom: '1.2rem' }} />
          <h1 className="syne" style={{ fontSize: 'clamp(1rem, 7vw, 5.6rem)', fontWeight: 'bolder', lineHeight: 2.08, letterSpacing: '-0.02em', marginBottom: '0.85rem' }}>
            <span className="gradient-text-amber">Nutrition</span>
          </h1>
          <p style={{ fontSize: 'clamp(15px, 2vw, 18px)', color: 'rgba(255,255,255,0.55)', maxWidth: 520, lineHeight: 1.65, fontWeight: 300 }}>
            Face à la crise nutritionnelle à Goma et au Nord-Kivu, TUMAINI LETU ASBL lutte contre la malnutrition infantile, distribue des vivres et forme les communautés pour un avenir alimentaire durable.
          </p>
        </div>
        <div style={{ width: 48, height: 2, background: 'linear-gradient(90deg, transparent, #eab308, transparent)', margin: '2rem auto', animation: 'heroFadeUp 0.7s ease 0.35s both' }} />
        {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14, width: '100%', maxWidth: 700, marginBottom: '2rem' }}>
          {stats.map(s => <StatCard key={s.label} {...s} />)}
        </div> */}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem', animation: 'heroFadeUp 0.7s ease 1s both' }}>
          {[
            { label: 'Faire un don', bg: '#eab308', color: '#fff', border: 'none' },
            { label: 'Nos programmes', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
            { label: 'Nous rejoindre', bg: '#fff', color: '#eab308', border: 'none' },
            { label: 'Nous contacter', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
          ].map(b => (
            <RippleButton key={b.label} style={{
              padding: '0.7rem 1.4rem', borderRadius: 12,
              background: b.bg, color: b.color, border: b.border,
              fontSize: 14, fontWeight: 500, fontFamily: 'DM Sans, sans-serif',
              backdropFilter: 'blur(10px)', transition: 'all 0.25s ease',
            }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >{b.label}</RippleButton>
          ))}
        </div>
        <div style={{ marginTop: '3rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', opacity: 0.35, animation: 'heroFadeUp 0.7s ease 1.2s both' }}>
          <span style={{ fontSize: 10, letterSpacing: '0.2em', fontFamily: 'Syne, sans-serif' }}>DÉFILER</span>
          <div style={{ width: 1, height: 36, background: 'rgba(255,255,255,0.4)', animation: 'floatY 2s ease-in-out infinite' }} />
        </div>
      </div>
    </header>
  );
};

/* ============================================================
   INTRO STRIP
   ============================================================ */
const IntroStrip = () => (
  <section style={{
    background: '#2d1a00',
    padding: '3rem 2rem',
    overflow: 'hidden',
    position: 'relative',
  }}>
    <div style={{
      position: 'absolute', inset: 0,
      backgroundImage: 'repeating-linear-gradient(-60deg, transparent, transparent 40px, rgba(255,255,255,0.015) 40px, rgba(255,255,255,0.015) 41px)',
      pointerEvents: 'none',
    }} />
    <div style={{
      maxWidth: 1140, margin: '0 auto',
      display: 'flex', flexWrap: 'wrap', alignItems: 'center',
      gap: '2rem', justifyContent: 'space-between',
    }}>
      <div style={{ flex: '1 1 300px' }}>
        <p className="playfair" style={{
          fontSize: 'clamp(1.4rem, 3vw, 2.2rem)',
          color: '#fde68a',
          lineHeight: 1.45,
          fontStyle: 'italic',
          fontWeight: 400,
        }}>
          "Nourrir un enfant aujourd'hui, c'est construire une nation demain."
        </p>
        <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.08em', fontFamily: 'Syne, sans-serif' }}>— TUMAINI LETU ASBL</p>
      </div>
      <div style={{ flex: '1 1 260px', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        {[
          { n: '64', l: 'Enfants aidés', Icon: PiBabyBold },
          { n: '20', l: 'Familles', Icon: GiWheat },
          // { n: '320+', l: 'Formations', Icon: FaBookOpen },
        ].map(({ n, l, Icon }) => (
          <div key={l} style={{
            flex: '1 1 80px', textAlign: 'center',
            padding: '1.2rem 0.75rem',
            borderRadius: 14,
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.4rem' }}>
              <Icon size={20} color="#fbbf24" />
            </div>
            <p className="syne" style={{ fontSize: 22, fontWeight: 800, color: '#fbbf24' }}>{n}</p>
            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginTop: '0.2rem', lineHeight: 1.4 }}>{l}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================================================
   MISSION SECTION
   ============================================================ */
const MissionSection = ({ activeTab, setActiveTab }) => (
  <section style={{ background: '#fffbf0', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    <div className="playfair" style={{
      position: 'absolute', top: -40, left: -20,
      fontSize: 'clamp(200px,25vw,360px)',
      fontWeight: 900, color: 'rgba(234,179,8,0.04)',
      lineHeight: 1, pointerEvents: 'none', userSelect: 'none',
      letterSpacing: '-0.05em',
    }}>N</div>

    <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2.5rem' }}>
        <div style={{ width: 48, height: 3, background: '#eab308', borderRadius: 2 }} />
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#eab308', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Mission & Engagement</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'start' }} className="mission-grid">
        <div>
          <h2 className="playfair" style={{
            fontSize: 'clamp(2rem, 4vw, 3.2rem)',
            fontWeight: 900, lineHeight: 1.12,
            color: '#1a1000', marginBottom: '1.5rem',
            letterSpacing: '-0.02em',
          }}>
            Combattre la faim,<br />
            <span style={{ color: '#eab308', fontStyle: 'italic' }}>nourrir l'espoir.</span>
          </h2>
          <p style={{ fontSize: 15, color: '#6b4a00', lineHeight: 1.85, marginBottom: '2rem' }}>
            La région de Goma et le Nord-Kivu font face à une situation nutritionnelle critique. TUMAINI LETU ASBL intervient activement pour lutter contre la malnutrition infantile, distribuer des vivres aux déplacés de guerre et former les communautés à des pratiques alimentaires durables.
          </p>
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.75rem' }}>
            {['mission', 'engagement'].map(tab => (
              <button key={tab} onClick={() => setActiveTab(tab)} style={{
                padding: '0.55rem 1.3rem', borderRadius: 99,
                border: activeTab === tab ? '1.5px solid #eab308' : '1.5px solid rgba(234,179,8,0.2)',
                background: activeTab === tab ? '#eab308' : 'transparent',
                color: activeTab === tab ? '#fff' : '#eab308',
                fontWeight: 700, fontSize: 12,
                letterSpacing: '0.05em',
                cursor: 'pointer', transition: 'all 0.25s ease',
              }}>
                {tab === 'mission' ? 'Notre mission' : 'Notre engagement'}
              </button>
            ))}
          </div>

          {activeTab === 'mission' ? (
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
              {[
                'Lutter contre la malnutrition infantile aiguë sévère',
                'Distribuer des rations alimentaires d\'urgence aux déplacés',
                'Former les communautés à la nutrition locale et durable',
                'Soutenir les petits producteurs agricoles',
                'Assurer l\'accès à l\'eau potable et à l\'hygiène',
                'Mettre en place des cantines scolaires inclusives',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', fontSize: 14, color: '#3d2a00', lineHeight: 1.7 }}>
                  <span style={{
                    width: 22, height: 22, borderRadius: 6, flexShrink: 0, marginTop: 1,
                    background: 'linear-gradient(135deg, #eab308, #fbbf24)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, color: '#fff', fontWeight: 800,
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
              {[
                "Transformer une agriculture de subsistance en une activité lucrative grâce à des techniques modernes et des semences de qualité.",
                "Assurer la prise en charge médicale et nutritionnelle des enfants souffrant de malnutrition aiguë avec complications hospitalières.",
                "Sensibiliser durablement les communautés aux pratiques ANJE (Alimentation du Nourrisson et du Jeune Enfant) pour réduire la mortalité infantile.",
              ].map((p, i) => (
                <p key={i} style={{ fontSize: 14, color: '#6b4a00', lineHeight: 1.85, paddingLeft: '1rem', borderLeft: '3px solid #eab308' }}>{p}</p>
              ))}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {[
            { num: '01', label: 'Nutrition & Alimentation', color: '#eab308', bg: '#fffbeb', Icon: IoNutrition },
            { num: '02', label: 'Agriculture Durable', color: '#84cc16', bg: '#f7ffe0', Icon: GiFarmTractor },
            { num: '03', label: 'Santé Infantile', color: '#f97316', bg: '#fff7ed', Icon: PiBabyBold },
            { num: '04', label: 'Eau & Hygiène', color: '#06b6d4', bg: '#f0fdff', Icon: BsDropletFill },
          ].map(item => (
            <div key={item.num} className="domain-card" style={{
              display: 'flex', alignItems: 'center', gap: '1.25rem',
              padding: '1.25rem 1.5rem',
              borderRadius: 16,
              background: item.bg,
              border: `1px solid ${item.color}20`,
            }}>
              <div style={{
                width: 50, height: 50, borderRadius: 12, flexShrink: 0,
                background: item.color + '18',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <item.Icon size={22} color={item.color} />
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 10, color: item.color, fontWeight: 700, letterSpacing: '0.12em', fontFamily: 'Syne, sans-serif', marginBottom: '0.25rem' }}>AXE {item.num}</p>
                <p className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#1a1000' }}>{item.label}</p>
              </div>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: item.color + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.color, fontSize: 14 }}>→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

/* ============================================================
   DOMAINS / PROGRAMMES SECTION
   ============================================================ */
const DomainsSection = () => {
  const domains = [
    { Icon: IoNutrition, color: '#eab308', title: 'Éducation nutritionnelle', desc: 'Sensibilisation et formation à une alimentation équilibrée à partir des produits locaux disponibles pour lutter contre la malnutrition.' },
    { Icon: GiWheat, color: '#84cc16', title: 'Distribution d\'urgence', desc: 'Fourniture de rations de vivres (farine, huile, légumineuses) aux déplacés de guerre, assortie de l\'instauration de cantines scolaires.' },
    { Icon: LuSprout, color: '#22c55e', title: 'Relance agricole', desc: 'Distribution de semences de qualité et d\'outils aratoires pour les potagers familiaux, relançant une production vivrière locale.' },
    { Icon: GiChicken, color: '#f97316', title: 'Élevage de subsistance', desc: 'Introduction du petit élevage pour assurer un apport régulier en protéines aux familles les plus vulnérables.' },
    { Icon: MdOutlineLocalHospital, color: '#ef4444', title: 'Prise en charge médicale', desc: 'Soins hospitaliers pour les enfants souffrant de malnutrition aiguë sévère avec complications, avec suivi nutritionnel thérapeutique.' },
    { Icon: GiWell, color: '#06b6d4', title: 'Accès à l\'eau potable', desc: 'Aménagement de sources et distribution de kits de purification d\'eau pour prévenir les maladies liées à l\'eau insalubre.' },
    { Icon: TbToiletPaper, color: '#8b5cf6', title: 'Hygiène domestique', desc: 'Construction de latrines pour stopper les maladies diarrhéiques, causes directes de malnutrition et de mortalité infantile.' },
    { Icon: LuMilk, color: '#ec4899', title: 'Pratiques ANJE', desc: 'Sensibilisation à l\'Alimentation du Nourrisson et du Jeune Enfant : allaitement maternel exclusif et diversification alimentaire précoce.' },
    { Icon: GiCookingPot, color: '#f59e0b', title: 'Démonstrations culinaires', desc: 'Sessions pratiques pour apprendre à cuisiner des bouillies enrichies locales et des repas équilibrés à moindre coût.' },
    { Icon: HiOutlineAcademicCap, color: '#0ea5e9', title: 'Formations académiques', desc: 'Enseignement technique en nutrition et diététique pour former une main-d\'œuvre locale qualifiée et durable.' },
    { Icon: FaTractor, color: '#84cc16', title: 'Soutien aux producteurs', desc: 'Accompagnement des petits producteurs pour transformer une agriculture de subsistance en une activité économique rentable.' },
    { Icon: FaSchool, color: '#eab308', title: 'Cantines scolaires', desc: 'Mise en place de cantines scolaires pour garantir au moins un repas équilibré par jour aux enfants scolarisés dans les zones défavorisées.' },
  ];

  return (
    <section style={{ background: '#1a0e00', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div className="dot-pattern-amber" style={{ position: 'absolute', inset: 0, opacity: 0.4, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '1.5rem', marginBottom: '3.5rem' }}>
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#fbbf24', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>— Programmes d'intervention</p>
            <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.1 }}>
              Douze axes<br /><span style={{ color: '#fbbf24', fontStyle: 'italic' }}>d'action</span>
            </h2>
          </div>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', maxWidth: 320, lineHeight: 1.75 }}>
            Des interventions intégrées couvrant l'alimentation, la santé, l'hygiène et l'éducation pour une nutrition durable.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1px', background: 'rgba(255,255,255,0.06)', borderRadius: 20, overflow: 'hidden' }}>
          {domains.map((d) => (
            <div key={d.title} className="domain-card" style={{
              padding: '2rem',
              background: '#1a0e00',
              position: 'relative', overflow: 'hidden',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = d.color + '12'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#1a0e00'; }}
            >
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 2, background: d.color, opacity: 0.6 }} />
              <div style={{ marginBottom: '1rem' }}>
                <d.Icon size={32} color={d.color} />
              </div>
              <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: '0.6rem' }}>{d.title}</h3>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.75 }}>{d.desc}</p>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
                marginTop: '1.25rem', fontSize: 12, color: d.color,
                fontFamily: 'Syne, sans-serif', fontWeight: 700, letterSpacing: '0.06em',
              }}>
                EN SAVOIR + <span>→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ============================================================
   ACTIONS SECTION
   ============================================================ */
const ActionsSection = () => {
  const actions = [
    { num: '01', title: 'Distribution alimentaire', desc: 'Rations de farine, huile et légumineuses pour les déplacés de guerre et familles vulnérables à Goma et au Nord-Kivu.', color: '#eab308', Icon: MdOutlineFastfood, tag: 'Urgence' },
    { num: '02', title: 'Thérapie nutritionnelle', desc: 'Prise en charge médicale hospitalisée des enfants souffrant de malnutrition aiguë sévère avec suivi nutritionnel personnalisé.', color: '#ef4444', Icon: MdOutlineLocalHospital, tag: 'Santé' },
    { num: '03', title: 'Potagers familiaux', desc: 'Distribution de semences sélectionnées et d\'outils pour relancer la production vivrière locale et l\'autonomie alimentaire.', color: '#84cc16', Icon: PiPlantBold, tag: 'Agriculture' },
    { num: '04', title: 'Cantines scolaires', desc: 'Un repas équilibré garanti chaque jour pour les enfants scolarisés, combinant nutrition et maintien de la fréquentation scolaire.', color: '#f97316', Icon: FaUtensils, tag: 'Éducation' },
  ];

  return (
    <section style={{ background: '#fffbf0', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div className="stripe-bg-amber" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem' }}>
          <div style={{ width: 48, height: 3, background: '#eab308', borderRadius: 2 }} />
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#eab308', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Actions concrètes</span>
        </div>
        <h2 className="playfair" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, color: '#1a1000', lineHeight: 1.12, marginBottom: '3rem' }}>
          Ce que nous<br /><span style={{ fontStyle: 'italic', color: '#eab308' }}>faisons</span>
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.5rem' }} className="actions-grid">
          {actions.map((a, i) => (
            <div key={a.title} data-aos="fade-up" data-aos-delay={i * 80} style={{
              borderRadius: 20, overflow: 'hidden', position: 'relative',
              background: '#fff',
              border: '1px solid rgba(0,0,0,0.06)',
              boxShadow: '0 2px 20px rgba(0,0,0,0.04)',
              transition: 'transform 0.35s cubic-bezier(0.34,1.2,0.64,1), box-shadow 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = `0 20px 40px ${a.color}18`; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 20px rgba(0,0,0,0.04)'; }}
            >
              <div style={{ height: 5, background: a.color }} />
              <div style={{ padding: '1.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                  <span className="syne" style={{ fontSize: 11, color: 'rgba(0,0,0,0.18)', fontWeight: 800, letterSpacing: '0.05em' }}>{a.num}</span>
                  <span style={{
                    fontSize: 10, fontWeight: 700, letterSpacing: '0.1em',
                    color: a.color, background: a.color + '15',
                    padding: '0.25rem 0.65rem', borderRadius: 99,
                    fontFamily: 'Syne, sans-serif', textTransform: 'uppercase',
                  }}>{a.tag}</span>
                </div>
                <div style={{ marginBottom: '1rem' }}>
                  <a.Icon size={36} color={a.color} />
                </div>
                <h3 className="syne" style={{ fontSize: 18, fontWeight: 800, color: '#1a1000', marginBottom: '0.6rem' }}>{a.title}</h3>
                <p style={{ fontSize: 13, color: '#7a5a00', lineHeight: 1.75 }}>{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ============================================================
   WHY SECTION
   ============================================================ */
const WhySection = () => {
  const reasons = [
    { Icon: RiEmotionSadLine, color: '#ef4444', title: 'Malnutrition aiguë', desc: 'Des milliers d\'enfants souffrent de malnutrition sévère dans le Nord-Kivu. Sans intervention rapide, les conséquences peuvent être irréversibles.' },
    { Icon: RiAlarmWarningLine, color: '#f97316', title: 'Crise humanitaire', desc: 'Les déplacements de guerre ont aggravé l\'insécurité alimentaire. Des familles entières se retrouvent sans ressources ni accès à la nourriture.' },
    { Icon: GiWheat, color: '#84cc16', title: 'Potentiel agricole', desc: 'La région possède un fort potentiel agricole inexploité. Accompagner les producteurs locaux, c\'est créer une autonomie alimentaire durable.' },
    { Icon: PiBabyBold, color: '#eab308', title: 'Enfants à risque', desc: 'Les enfants de moins de 5 ans sont les plus vulnérables. Agir tôt sur leur nutrition garantit leur développement cognitif et physique.' },
    { Icon: BsGraphDownArrow, color: '#8b5cf6', title: 'Insécurité alimentaire', desc: 'Des méthodes agricoles obsolètes et un accès limité aux intrants freinent la production locale et maintiennent les familles dans la précarité.' },
    { Icon: BsLightbulb, color: '#06b6d4', title: 'Solutions locales', desc: 'Nous privilégions les ressources et savoirs locaux pour des interventions durables, adaptées aux réalités culturelles et environnementales.' },
  ];

  return (
    <section style={{ background: '#1a0e00', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div style={{ position: 'absolute', bottom: 0, right: 0, width: 500, height: 500, borderRadius: '50%', background: 'rgba(234,179,8,0.05)', filter: 'blur(120px)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#fbbf24', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Pourquoi agir maintenant</p>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.12 }}>
            L'urgence de<br /><span style={{ fontStyle: 'italic', color: '#fbbf24' }}>la cause</span>
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
          {reasons.map((r, i) => (
            <div key={r.title} data-aos="fade-up" data-aos-delay={i * 60} style={{
              display: 'flex', gap: '1.25rem', alignItems: 'flex-start',
              padding: '1.5rem',
              borderRadius: 16,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              transition: 'all 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = r.color + '0d'; e.currentTarget.style.borderColor = r.color + '30'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'; }}
            >
              <div style={{ width: 48, height: 48, borderRadius: 12, background: r.color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <r.Icon size={22} color={r.color} />
              </div>
              <div>
                <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: '0.4rem' }}>{r.title}</h3>
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.75 }}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div data-aos="fade-up" style={{
          marginTop: '3rem', borderRadius: 24, overflow: 'hidden',
          background: 'linear-gradient(135deg, #b45309 0%, #d97706 60%, #fbbf24 100%)',
          padding: 'clamp(2rem,4vw,3rem)',
          display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
          gap: '2rem', position: 'relative',
        }}>
          <div style={{ position: 'absolute', top: -60, right: -60, width: 240, height: 240, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', pointerEvents: 'none' }} />
          <div>
            <h3 className="playfair" style={{ fontSize: 'clamp(1.4rem, 3vw, 2.2rem)', fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: '0.5rem' }}>
              Ensemble contre la faim,<br />pour un avenir nourri.
            </h3>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)', maxWidth: 420, lineHeight: 1.7 }}>
              TUMAINI LETU place la dignité alimentaire au cœur de ses actions pour des communautés résilientes et autonomes.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <RippleButton style={{ padding: '0.85rem 2rem', borderRadius: 12, background: '#fff', color: '#b45309', fontSize: 14, fontWeight: 700, fontFamily: 'Syne, sans-serif' }}>Faire un don</RippleButton>
            <RippleButton style={{ padding: '0.85rem 2rem', borderRadius: 12, background: 'rgba(0,0,0,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)', fontSize: 14, fontWeight: 600 }}>En savoir plus</RippleButton>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ============================================================
   ACTORS SECTION
   ============================================================ */
const ActorsSection = () => (
  <section style={{ background: '#fffbf0', padding: '6rem 1.5rem', position: 'relative' }} data-aos="fade-up">
    <div style={{ maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem' }}>
        <div style={{ width: 48, height: 3, background: '#eab308', borderRadius: 2 }} />
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#eab308', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Les acteurs</span>
      </div>
      <h2 className="playfair" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, color: '#1a1000', lineHeight: 1.1, marginBottom: '3rem' }}>
        Qui s'implique<br /><span style={{ fontStyle: 'italic', color: '#eab308' }}>dans la cause ?</span>
      </h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
        {[
          { Icon: FaUserMd, color: '#ef4444', title: 'Équipes médicales', desc: 'Médecins, nutritionnistes et infirmiers assurent la prise en charge hospitalière et le suivi thérapeutique des enfants malnutris.' },
          { Icon: GiFarmTractor, color: '#84cc16', title: 'Agriculteurs locaux', desc: 'Petits producteurs formés aux techniques agricoles durables pour accroître leurs rendements et leur autonomie alimentaire.' },
          { Icon: FaSchool, color: '#eab308', title: 'Écoles & Parents', desc: 'Établissements scolaires partenaires des cantines et familles impliquées dans les programmes de sensibilisation nutritionnelle.' },
          { Icon: HiOutlineUsers, color: '#f97316', title: 'Communautés déplacées', desc: 'Familles déplacées par les conflits, bénéficiaires prioritaires des distributions alimentaires d\'urgence et des formations.' },
        ].map((a, i) => (
          <div key={a.title} data-aos="fade-up" data-aos-delay={i * 70} style={{
            borderRadius: 18, background: '#fff',
            border: '1px solid rgba(0,0,0,0.05)',
            boxShadow: '0 2px 16px rgba(0,0,0,0.04)',
            overflow: 'hidden',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = `0 16px 32px ${a.color}20`; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.04)'; }}
          >
            <div style={{ height: 90, background: `linear-gradient(135deg, ${a.color}15, ${a.color}05)`, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: `3px solid ${a.color}30` }}>
              <a.Icon size={38} color={a.color} />
            </div>
            <div style={{ padding: '1.25rem 1.5rem' }}>
              <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#1a1000', marginBottom: '0.5rem' }}>{a.title}</h3>
              <p style={{ fontSize: 13, color: '#7a5a00', lineHeight: 1.75 }}>{a.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================================================
   TESTIMONIALS SECTION
   ============================================================ */
const TestimonialsSection = () => (
  <section style={{ background: '#fdf4e0', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    <div className="playfair" style={{
      position: 'absolute', bottom: -60, right: -30,
      fontSize: 'clamp(180px,22vw,320px)',
      fontWeight: 900, color: 'rgba(234,179,8,0.06)',
      lineHeight: 1, pointerEvents: 'none', userSelect: 'none',
    }}>"</div>

    <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#eab308', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Témoignages</p>
        <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 900, color: '#1a1000', lineHeight: 1.12 }}>
          Voix de nos <span style={{ fontStyle: 'italic', color: '#eab308' }}>bénéficiaires</span>
        </h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {[
          { name: 'Amina BAHATI', role: 'Mère bénéficiaire, Goma', text: 'Grâce aux rations alimentaires de TUMAINI LETU, mes enfants ont retrouvé des forces. Mon fils aîné, qui souffrait de malnutrition, est retourné à l\'école.', Icon: FaHandHoldingHeart, color: '#eab308' },
          { name: 'Dr. Pascal MUHINDO', role: 'Médecin nutritionniste', text: 'Les cas de malnutrition sévère ont nettement diminué dans notre centre. Les interventions communautaires de TUMAINI LETU font une différence réelle sur le terrain.', Icon: FaUserMd, color: '#ef4444' },
          { name: 'Espérance MASIKA', role: 'Agricultrice formée', text: 'Les semences et les formations reçues ont transformé mon potager. Aujourd\'hui je nourris ma famille et je vends le surplus au marché local.', Icon: GiFarmTractor, color: '#84cc16' },
        ].map((t, i) => (
          <div key={t.name} className="testi-card" data-aos="fade-up" data-aos-delay={i * 80} style={{
            borderRadius: 20, background: '#fff',
            border: '1px solid rgba(0,0,0,0.05)',
            padding: '2rem',
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
            position: 'relative', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: t.color }} />
            <div className="playfair" style={{ fontSize: 80, color: t.color, opacity: 0.12, lineHeight: 0.8, marginBottom: '0.5rem', fontWeight: 900 }}>"</div>
            <p style={{ fontSize: 14, color: '#3d2a00', lineHeight: 1.85, fontStyle: 'italic', marginBottom: '1.5rem' }}>{t.text}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', paddingTop: '1rem', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', background: `linear-gradient(135deg, ${t.color}40, ${t.color}80)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <t.Icon size={20} color="#fff" />
              </div>
              <div>
                <p className="syne" style={{ fontSize: 13, fontWeight: 700, color: '#1a1000' }}>{t.name}</p>
                <p style={{ fontSize: 11, color: t.color, fontWeight: 500 }}>{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================================================
   CONTACT SECTION
   ============================================================ */
const ContactSection = () => (
  <section style={{ background: '#fff', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    <div style={{ maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: '4rem', alignItems: 'start' }} className="mission-grid">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <div style={{ width: 40, height: 3, background: '#eab308', borderRadius: 2 }} />
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#eab308', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Contact</span>
          </div>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 900, color: '#1a1000', lineHeight: 1.1, marginBottom: '1.5rem' }}>
            Rejoignez<br />le <span style={{ fontStyle: 'italic', color: '#eab308' }}>programme</span>
          </h2>
          <p style={{ fontSize: 14, color: '#7a5a00', lineHeight: 1.85, marginBottom: '2rem' }}>
            Chaque contribution compte. Rejoignez TUMAINI LETU pour lutter contre la malnutrition et construire un avenir alimentaire durable pour les communautés du Nord-Kivu.
          </p>
          {[
            { Icon: MdOutlineEmojiFoodBeverage, label: 'Email', val: 'info@tumainiletu.com' },
            { Icon: RiGovernmentLine, label: 'Zone d\'action', val: 'Goma & Nord-Kivu, RDC' },
            { Icon: IoNutrition, label: 'Mission', val: 'Lutte contre la malnutrition' },
          ].map(c => (
            <div key={c.label} style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', marginBottom: '1rem' }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: 'rgba(234,179,8,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <c.Icon size={16} color="#eab308" />
              </div>
              <div>
                <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', color: '#eab308', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase', marginBottom: '0.2rem' }}>{c.label}</p>
                <p style={{ fontSize: 13, color: '#3d2a00' }}>{c.val}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{
          background: '#fffbeb', borderRadius: 24,
          border: '1px solid rgba(234,179,8,0.1)',
          padding: '2.5rem',
          boxShadow: '0 4px 40px rgba(234,179,8,0.06)',
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
            {[{ ph: 'Nom complet', type: 'text' }, { ph: 'Adresse email', type: 'email' }].map(f => (
              <input key={f.ph} type={f.type} placeholder={f.ph} style={{
                padding: '0.9rem 1rem', borderRadius: 12,
                border: '1.5px solid rgba(234,179,8,0.15)',
                background: '#fff', fontSize: 14, color: '#1a1000',
                outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s',
              }}
                onFocus={e => e.target.style.borderColor = '#eab308'}
                onBlur={e => e.target.style.borderColor = 'rgba(234,179,8,0.15)'}
              />
            ))}
          </div>
          <input type="tel" placeholder="Téléphone" style={{
            width: '100%', padding: '0.9rem 1rem', borderRadius: 12, marginBottom: '0.75rem',
            border: '1.5px solid rgba(234,179,8,0.15)',
            background: '#fff', fontSize: 14, color: '#1a1000',
            outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s', boxSizing: 'border-box',
          }}
            onFocus={e => e.target.style.borderColor = '#eab308'}
            onBlur={e => e.target.style.borderColor = 'rgba(234,179,8,0.15)'}
          />
          <textarea rows={5} placeholder="Comment souhaitez-vous soutenir notre programme nutritionnel ?" style={{
            width: '100%', padding: '0.9rem 1rem', borderRadius: 12, marginBottom: '1.25rem',
            border: '1.5px solid rgba(234,179,8,0.15)',
            background: '#fff', fontSize: 14, color: '#1a1000', resize: 'none',
            outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s', boxSizing: 'border-box',
          }}
            onFocus={e => e.target.style.borderColor = '#eab308'}
            onBlur={e => e.target.style.borderColor = 'rgba(234,179,8,0.15)'}
          />
          <RippleButton style={{
            width: '100%', padding: '0.9rem', borderRadius: 12,
            background: 'linear-gradient(135deg, #b45309, #eab308)',
            color: '#fff', fontSize: 14, fontWeight: 700,
            fontFamily: 'Syne, sans-serif', letterSpacing: '0.04em',
          }}>
            Envoyer le message →
          </RippleButton>
        </div>
      </div>
    </div>
  </section>
);

/* ============================================================
   FAQ SECTION
   ============================================================ */
const FaqSection = ({ openFaq, setOpenFaq }) => {
  const faqs = [
    { q: "Comment puis-je aider les enfants malnutris de Goma ?", a: "Vous pouvez faire un don financier, parrainer un enfant ou vous porter bénévole. Contactez-nous via le formulaire ou par email pour connaître les modalités d'intervention." },
    { q: "Comment sont sélectionnées les familles bénéficiaires ?", a: "Les familles bénéficiaires sont identifiées par nos équipes terrain en collaboration avec les autorités locales et les centres de santé, sur base de critères de vulnérabilité définis." },
    { q: "Puis-je contribuer en nature plutôt qu'en argent ?", a: "Oui, nous acceptons les dons en nature : denrées alimentaires non périssables, semences, outils agricoles, matériel médical ou équipements scolaires. Contactez-nous pour coordination." },
    { q: "Quels sont les résultats de vos programmes nutritionnels ?", a: "Nos interventions ont permis la récupération nutritionnelle de plus de 5 200 enfants, la formation de 320 communautés et le soutien à 1 800 familles grâce aux distributions et potagers familiaux." },
    { q: "Comment les formations en nutrition sont-elles dispensées ?", a: "Via des ateliers communautaires, des démonstrations culinaires pratiques, et des séances de sensibilisation dans les écoles et centres de santé. Nos formateurs utilisent des supports adaptés en langues locales." },
  ];

  return (
    <section style={{ background: '#1a0e00', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div style={{ maxWidth: 780, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#fbbf24', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Questions fréquentes</p>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.12 }}>
            On répond à<br /><span style={{ fontStyle: 'italic', color: '#fbbf24' }}>vos questions</span>
          </h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {faqs.map((item, i) => (
            <div key={i} className="faq-item" onClick={() => setOpenFaq(openFaq === i ? null : i)} style={{
              background: openFaq === i ? 'rgba(234,179,8,0.08)' : 'rgba(255,255,255,0.04)',
              borderRadius: 14,
              border: openFaq === i ? '1px solid rgba(234,179,8,0.25)' : '1px solid rgba(255,255,255,0.07)',
              cursor: 'pointer', overflow: 'hidden',
              transition: 'all 0.25s ease',
            }}>
              <div style={{ padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
                <p className="syne" style={{ fontSize: 14, fontWeight: 700, color: openFaq === i ? '#fbbf24' : '#fde8a0', lineHeight: 1.5 }}>{item.q}</p>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
                  background: openFaq === i ? '#eab308' : 'rgba(255,255,255,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, color: openFaq === i ? '#fff' : 'rgba(255,255,255,0.4)',
                  transition: 'all 0.3s',
                  transform: openFaq === i ? 'rotate(45deg)' : 'none',
                  fontWeight: 200,
                }}>+</div>
              </div>
              <div style={{ maxHeight: openFaq === i ? 200 : 0, overflow: 'hidden', transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)' }}>
                <p style={{ padding: '0 1.5rem 1.25rem', fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85 }}>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ============================================================
   SUPPORT STRIP
   ============================================================ */
const SupportStrip = () => (
  <section style={{ background: '#fdf4e0', padding: '4rem 1.5rem' }} data-aos="fade-up">
    <div style={{
      maxWidth: 700, margin: '0 auto', textAlign: 'center',
      background: '#fff', borderRadius: 20, padding: '3rem 2rem',
      border: '1px solid rgba(234,179,8,0.1)',
      boxShadow: '0 4px 32px rgba(234,179,8,0.07)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
        <IoNutrition size={40} color="#eab308" />
      </div>
      <h2 className="playfair" style={{ fontSize: 'clamp(1.4rem, 3vw, 2rem)', fontWeight: 900, color: '#1a1000', marginBottom: '0.75rem' }}>
        Besoin d'informations ?
      </h2>
      <p style={{ fontSize: 14, color: '#7a5a00', marginBottom: '1.75rem', lineHeight: 1.75, maxWidth: 420, margin: '0 auto 1.75rem' }}>
        Contactez notre équipe nutrition pour tout renseignement, partenariat ou soutien. Nous répondons sous 48h.
      </p>
      <RippleButton
        style={{ padding: '0.85rem 2rem', borderRadius: 12, background: '#eab308', color: '#fff', fontSize: 14, fontWeight: 700, fontFamily: 'Syne, sans-serif', letterSpacing: '0.04em' }}
        onClick={() => window.location.href = "mailto:info@tumainiletu.com?subject=Question%20Nutrition"}
      >Contacter l'équipe →</RippleButton>
    </div>
  </section>
);

/* ============================================================
   MAIN NUTRITION PAGE
   ============================================================ */
const Nutrition = () => {
  const [loading, setLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);
  const [activeTab, setActiveTab] = useState('mission');

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 60 });
    const t = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif', background: '#fdf8f0', color: '#1a1000', overflowX: 'hidden' }}>
      <GlobalStyles />
      <PageLoader loading={loading} />
      <Navbar />
      <Hero video={bgVideo} />

      <IntroStrip />
      <MissionSection activeTab={activeTab} setActiveTab={setActiveTab} />
      <DomainsSection />
      <ActionsSection />
      <WhySection />
      <ActorsSection />
      <TestimonialsSection />
      <ContactSection />
      <FaqSection openFaq={openFaq} setOpenFaq={setOpenFaq} />
      <SupportStrip />

      <Footer />
    </div>
  );
};

export default Nutrition;
